import en from './en.json';
import de from './de-DE.json';
import es from './es-ES.json';
import esCL from './es-CL.json';
import fr from './fr-FR.json';
import nl from './nl-NL.json';
import it from './it-IT.json';
import fi from './fi-FI.json';
import enIE from './en-IE.json';
import frCH from './fr-CH.json';
import deCH from './de-CH.json';
import daDK from './da-DK.json';
import itCH from './it-CH.json';
import btBR from './pt-BR.json';
import etEE from './et-EE.json';
import deLU from './de-LU.json';
import frLU from './fr-LU.json';
import ptPT from './pt-PT.json';
import skSK from './sk-SK.json';
import slSI from './sl-SI.json';
import elCY from './el-CY.json';
import elGR from './el-GR.json';
import ltLT from './lt-LT.json';
import enMT from './en-MT.json';
import nbNO from './nb-NO.json';
import svSE from './sv-SE.json';
import huHU from './hu-HU.json';
import plPL from './pl-PL.json';
import roRO from './ro-RO.json';
import csCZ from './cs-CZ.json';
import bgBG from './bg-BG.json';

export default  {
	en,
	'de-DE': de,
	'es-ES': es,
	'es-CL': esCL,
	'fr-FR': fr,
	'nl-NL': nl,
	'it-IT': it,
	'fi-FI': fi,
	'en-IE': enIE,
	'fr-CH': frCH,
	'de-CH': deCH,
	'it-CH': itCH,
	'pt-BR': btBR,
	'et-EE': etEE,
	'de-LU': deLU,
	'fr-LU': frLU,
	'pt-PT': ptPT,
	'sk-SK': skSK,
	'sl-SI': slSI,
	'el-CY': elCY,
	'el-GR': elGR,
	'lt-LT': ltLT,
	'en-MT': enMT,
	'nb-NO': nbNO,
	'sv-SE': svSE,
	'hu-HU': huHU,
	'pl-PL': plPL,
	'ro-RO': roRO,
	'cs-CZ': csCZ,
	'bg-BG': bgBG,
	'da-DK': daDK,
};